<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>{{operatorTip}}{{editName}}</template>

  <template #body>
    <el-form ref="form" :model="model" @keydown.native.enter.prevent="onSaveContinueBtnClick">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="用户名" prop="username" :rules="[{
            required: true,
            message: '请输入用户名'
          }]">
            <el-input v-model.trim="model.username" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item v-if="operator === 1" label="密码" prop="password" :rules="[{
            required: true,
            message: '请输入密码'
          }]">
            <el-input v-model.trim="model.password" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="真实姓名" prop="realName" :rules="[{
            required: true,
            message: '请输入用户姓名'
          }]">
            <el-input v-model="model.realName" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="联系方式" prop="mobile">
            <el-input v-model.trim="model.mobile" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="邮箱" prop="email">
            <el-input v-model.trim="model.email" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item label="角色" prop="roleIdList" :rules="[{
            required: true,
            type: 'array',
            message: '请至少选择一个角色'
          }]">
            <el-select v-model="model.roleIdList" multiple style="width:100%;">
              <el-option
                v-for="role in roles"
                :key="role.id"
                :value="role.id"
                :label="role.name"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="审核权限" prop="auditAuth">
            <div style="width:100%;margin-top:40px;">
              <el-checkbox-group v-model="auditAuths" @change="onAuditAuthsChanged">
                <el-checkbox
                  v-for="auditStage in auditStages"
                  :key="auditStage.value"
                  :label="auditStage.value"
                >{{auditStage.label}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="状态" prop="status">
        <el-switch v-model="model.status"></el-switch>
      </el-form-item>

      <el-form-item label="关联仪器" prop="siteDeviceIds">
        <section class="tree-container border" style="height:300px;">
          <el-tree
            ref="deviceTree"
            :key="treeKey"
            :data="deviceTree"
            :props="{label: 'name'}"
            :show-checkbox="true"
            :check-on-click-node="true"
            node-key="id"
            @check="onDeviceCheckChange"
          />
        </section>
      </el-form-item>
    </el-form>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick1">保存</el-button>
    <el-button v-if="operator === 1" type="orange" plain class="btn save-continue-btn" @click="onSaveContinueBtnClick">保存并继续</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../BaseEditor'
import numberToCN from '../../../utils/numberToCN'

export default {
  name: 'UserEditor',
  extends: BaseEditor,
  props: {
    org: {
      required: true
    },
    orgId: {
      required: true
    },
    maxAuditStage: {
      required: true,
      type: Number
    },
    orgSiteDevices: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      roles: [],
      auditAuths: [],
      treeKey: 0
    }
  },
  computed: {
    apiKey () {
      return 'User'
    },
    idKey () {
      return 'id'
    },
    nameKey () {
      return 'name'
    },
    editName () {
      return '用户'
    },
    auditStages () {
      let {maxAuditStage} = this
      return new Array(maxAuditStage).fill(null).map((n, index) => ({
        value: 1 << index,
        label: `${numberToCN[index + 1]}审`
      }))
    },
    filterSiteDeviceMap () {
      return this.orgSiteDevices.reduce((map, siteDevice) => {
        map[siteDevice.id] = siteDevice
        return map
      }, {})
    },
    deviceTree () {
      let {filterSiteDeviceMap} = this
      let org = this.org || {}
      return Object.values((org.siteDeviceIds || []).reduce((siteMap, siteDeviceId) => {
        let siteDevice = filterSiteDeviceMap[siteDeviceId]

        if (siteDevice) {
          let {siteId} = siteDevice
          let site = siteMap[siteId]

          if (!site) {
            site = siteMap[siteId] = {
              id: siteId,
              name: siteDevice.siteName,
              children: []
            }
          }

          site.children.push({
            id: siteDevice.id,
            name: siteDevice.deviceName,
            parentId: siteId
          })
        }

        return siteMap
      }, {}))
    }
  },
  methods: {
    initModel (model) {
      this.auditAuths = []

      const deviceTree = this.$refs.deviceTree

      deviceTree && deviceTree.setCheckedKeys([])

      return {
        id: null,
        username: '',
        password: '',
        realName: '',
        orgId: this.orgId,
        mobile: '',
        email: '',
        roleIdList: model ? model.roleIdList : [],
        siteDeviceIds: [],
        auditAuth: 0,
        status: true
      }
    },
    onOpen () {
      this.treeKey++
    },
    onAuditAuthsChanged () {
      this.model.auditAuth = this.auditAuths.reduce((count, auditAuth) => count | auditAuth, 0)
    },
    afterGetDetail (model) {
      let {auditAuth} = model
      let auditAuths = []

      while (auditAuth > 0) {
        let bit = -auditAuth & auditAuth
        auditAuth ^= bit
        auditAuths.push(bit)
      }

      this.auditAuths = auditAuths

      // 权限
      let excludeSiteDeviceIds = []
      let {siteDeviceIds} = model

      if (Array.isArray(siteDeviceIds)) {
        let {filterSiteDeviceMap} = this

        excludeSiteDeviceIds = siteDeviceIds.filter(siteDeviceId => !filterSiteDeviceMap[siteDeviceId])

        let refTree = this.getDeviceTree()
        refTree && refTree.setCheckedKeys(siteDeviceIds)
      }

      this.excludeSiteDeviceIds = excludeSiteDeviceIds
    },
    onSaveBtnClick1 () {
      let {model} = this
      let {realName} = model

      if (realName) {
        model.realName = realName.trim()
      }

      this.onSaveBtnClick()
    },
    onDeviceCheckChange () {
      let checkedNodeList = this.getDeviceTree().getCheckedNodes()
      this.model.siteDeviceIds = checkedNodeList.filter(item => !Array.isArray(item.children)).map(item => item.id)
    },
    beforeSave () {
      this.model.siteDeviceIds = this.model.siteDeviceIds.concat(this.excludeSiteDeviceIds || [])
    },
    getDeviceTree () {
      return this.$refs.deviceTree
    }
  },
  created () {
    this.$api.ProfileRole.getList().then(roles => {
      this.roles = Object.freeze(roles)
    }).catch(console.error)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/02Org/UserEditor.vue